<style scoped lang="scss" type="text/scss">
    .school-overview-container {
        .search-bar {
            margin-bottom: 1rem;
        }
    }

    .file-download-panel {
        position: absolute;
        right: 0;
        top: 0;
    }
</style>

<template>
    <div class="school-overview-container global-relative">
        <el-input class="search-bar full-width" placeholder="请输入校名，按回车搜索" v-model="keyword" clearable
                  @keypress.native.enter="resetAndSearchSchool"
        >
        </el-input>

        <loading-placeholder :loading="requesting"></loading-placeholder>
        <el-table :data="schools" stripe border size="small" style="width: 100%">
            <el-table-column type="index" :index="indexMethod" label="序号" align="center" width="80"></el-table-column>
            <el-table-column prop="name" label="学校名称" align="center" min-width="120"></el-table-column>
            <el-table-column prop="manager_name" label="管理者" align="center" width="120">
                <template slot-scope="scope">
                    <status-tag v-if="null === scope.row.manager_name"
                                :success="null !== scope.row.manager_name"></status-tag>
                    <span v-else>{{ scope.row.manager_name }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="badge_url" label="校徽" align="center" width="90">
                <template slot-scope="scope">
                    <status-tag :success="null !== scope.row.badge_url"></status-tag>
                </template>
            </el-table-column>
            <el-table-column prop="tags" label="学校标签" align="center" width="120">
                <template slot-scope="scope">
                    <status-tag v-if="0 === scope.row.tags.length" :success="scope.row.tags.length > 0"></status-tag>
                    <span v-else>{{ scope.row.tags.join(', ') }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="region_merge_name" label="省市区" align="center" min-width="150">
                <template slot-scope="scope">
                    <status-tag v-if="null === scope.row.region_merge_name"
                                :success="null !== scope.row.region_merge_name"></status-tag>
                    <span v-else>{{ scope.row.region_merge_name }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="address_detail" label="详细地址" align="center" min-width="120">
                <template slot-scope="scope">
                    <status-tag v-if="null === scope.row.address_detail"
                                :success="null !== scope.row.address_detail"></status-tag>
                    <span v-else>{{ scope.row.address_detail }}</span>
                </template>
            </el-table-column>
        </el-table>
        <file-download-panel class="file-download-panel"></file-download-panel>

        <pagination :page-size="pageSize" :current-page.sync="currentPage" :total="total"
                    @current-change="searchSchool">
        </pagination>
    </div>
</template>

<script>
    import StatusTag from '../../../../components/status-tag/index';
    import {handleSchools} from '../../../../utils/data-handler';
    import FileDownloadPanel from '../download-panel/file';
    import {updatePageOption, indexMethod} from '../../../../utils/page';

    export default {
        name: '',
        components: {
            StatusTag,
            FileDownloadPanel
        },
        created () {
            this.searchSchool();
        },
        data () {
            return {
                requesting: false,
                keyword: null,
                pageSize: 15,
                total: 0,
                currentPage: 1,
                schools: []
            };
        },
        computed: {
            page () {
                return {
                    page_size: this.pageSize,
                    page_num: this.currentPage
                };
            }
        },
        methods: {
            indexMethod (index) {
                return indexMethod(index, this);
            },
            resetAndSearchSchool () {
                this.currentPage = 1;
                this.searchSchool();
            },
            searchSchool () {
                return this.$store.dispatch('school/searchByFuzzyNameWithPagination', {
                    name: this.keyword,
                    ...this.page
                }).then(response => {
                    const data = response.data;
                    updatePageOption(this, data);
                    this.schools = handleSchools(data.list);
                });
            }
        }
    };
</script>
